












































































import { Buffer } from 'safe-buffer'
import Getters from '@/mixins/Getters'
import { ILoginProvider } from '@/typings'
import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import { walletFromMnemonic, walletFromPrivateKey, Wallet } from 'minterjs-wallet'

@Component({
  name: 'LoginProviders'
})
export default class LoginProviders extends Mixins(Getters) {
  protected mnemonic: string = ''
  protected privateKey: string = ''
  protected activeProvider: string = 'mnemonic'
  protected providers: ILoginProvider[] = [
    {
      name: 'mnemonic',
      title: 'Mnemonic Phrase',
      icon: 'fas fa-sign-in-alt'
    },
    {
      name: 'privateKey',
      title: 'Private Key',
      icon: 'fas fa-key'
    }
  ]

  get isProvider(): boolean {
    return (
      (this.activeProvider === 'mnemonic' && this.mnemonic !== '') ||
      (this.activeProvider === 'privateKey' && this.privateKey !== '')
    )
  }

  // Reset fields on provider type change
  @Watch('activeProvider')
  protected onActiveProviderChange() {
    this.mnemonic = ''
    this.privateKey = ''
  }

  // Set provider type
  protected setActiveProvider(name: string) {
    this.activeProvider = name
  }

  // Set Seed phrase to store
  protected setMnemonic() {
    this.dataStore.commitError(null)
    this.dataStore.commitMnemonic(this.mnemonic)
    setTimeout(() => {
      try {
        const wallet = walletFromMnemonic(this.mnemonic)
        const privateKey = wallet.getPrivateKeyString()
        this.dataStore.commitWallet(wallet)
        this.dataStore.commitPrivateKey(privateKey)
      } catch (e) {
        this.dataStore.commitError(e)
      }
    }, 100)
  }

  // Set PK to store
  protected setPrivateKey() {
    this.dataStore.commitError(null)
    this.dataStore.commitPrivateKey(this.privateKey)
    // Decode wallet from PK with delay to display loading properly
    setTimeout(() => {
      try {
        const privateKeyBuffer = Buffer.from(this.privateKey, 'hex')
        const wallet = walletFromPrivateKey(privateKeyBuffer)
        this.dataStore.commitWallet(wallet)
      } catch (e) {
        this.dataStore.commitError(e)
      }
    }, 100 )
  }

  // Reset
  protected clear() {
    this.mnemonic = ''
    this.privateKey = ''
    this.dataStore.commitWallet(null)
  }
}
